import './TimelineFields.scss';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import TimeLine from './TimeLine';
import GameDragLayer from './GameDragLayer';
import Spinner from './Spinner';

export default function TimelineFields({
  wrapRef,
  timeSlots,
  sortedFields,
  fieldFilter,
  renderFields,
  spinner,
}) {
  return (
    <DndProvider backend={HTML5Backend}>
      <GameDragLayer />
      <div className='timeline-fields-wrap' ref={wrapRef}>
        <TimeLine timeSlots={timeSlots} />
        <div className='fields-wrap'>{renderFields(sortedFields)}</div>
        <div className='single-field-wrap'>
          {renderFields(
            sortedFields.filter((field) => field.name === fieldFilter),
          )}
        </div>
        <Spinner show={spinner} />
      </div>
    </DndProvider>
  );
}
